import React, {Fragment, useEffect, useImperativeHandle, useState} from 'react';
import './HistoryPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import { useParams } from "react-router-dom";
import HistoryContainer from "root/HistoryContainer";

const HistoryPageBody = (props) =>
{
    let { provider_id } = useParams();

    return (
            <PageBodyWrapper title='Audit History'>
            <div className='table-section-rows'>
                <h5>Surveys</h5>
                <HistoryContainer provider_id={encodeURIComponent(provider_id)}/>
            </div>
            </PageBodyWrapper>
    )
}

export default HistoryPageBody;
